import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../../SidebarItem";

import {OMSRoutes} from "utils/OMSRoutes";

import {ReactComponent as ShopppingCartIcon} from "assets/img/shopping-cart.svg";

import {SidebarContext} from "../../../../../../SidebarContext";

function OrdersItem(props) {
    const {currentPath} = useContext(SidebarContext);

    const isSelected = currentPath.startsWith(OMSRoutes.ORDERS);

    return (
        <SidebarItem
            isTopLevel
            icon={<ShopppingCartIcon />}
            to={OMSRoutes.ORDERS_LIST}
            selected={isSelected}
        >
            <FormattedMessage id='sidebar.item.orders' />
        </SidebarItem>
    );
}

export default OrdersItem;
